// extracted by css-extract-rspack-plugin
export default {"root":"HeaderText_root__8oa85"};